/* global axios */
import ApiClient from './ApiClient';

class InboxHealthAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getHealthStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/health`);
  }

  registerWebhook(inboxId) {
    return axios.post(`${this.url}/${inboxId}/register_webhook`);
  }

  updateDirectSendStatus(inboxId, status) {
    return axios.patch(`${this.url}/${inboxId}/direct_send`, {
      direct_send_status: status,
    });
  }
}

export default new InboxHealthAPI();
